import React from 'react'

export default function ImportIcons() {
  return (
    <link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"></link>
  )
}
